import { useState } from "react";
import { BRAND } from "../../data/site";
import { Button } from "../ui/button";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Instagram, Menu } from "lucide-react";

const LINKS = [
    { label: "Chi Siamo", href: "#chi-siamo" },
    { label: "FAQ", href: "#faq" },
    { label: "Contatti", href: "#contatti" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
        <a
            href={BRAND.dmUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="announcement-bar"
            className="fixed top-0 z-50 w-full h-10 bg-[#E60000] flex items-center justify-center gap-2 px-4 text-white hover:bg-[#c40000] transition-colors"
        >
            <Instagram className="h-3.5 w-3.5 shrink-0" />
            <span className="text-[11px] sm:text-xs font-bold uppercase tracking-widest truncate">
                Reperiamo qualsiasi taglia e modello: scarpe, abbigliamento e accessori — mandaci una foto in DM
            </span>
        </a>
        <header data-testid="site-header" className="fixed top-10 z-50 w-full border-b border-[#262626] bg-black/60 backdrop-blur-xl">
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
                    <img src={BRAND.logo} alt={BRAND.name} className="h-10 w-10 object-cover rounded-sm" />
                    <span className="font-display font-bold uppercase tracking-tight text-lg text-white">
                        HYPE <span className="text-[#E60000]">SNEAKERS</span> 21
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                            className="text-sm font-semibold uppercase tracking-wide text-neutral-400 hover:text-white transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                    <Button asChild size="sm" className="rounded-sm bg-[#E60000] hover:bg-[#c40000] text-white font-bold uppercase">
                        <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="nav-instagram-btn">
                            <Instagram className="h-4 w-4 mr-2" /> Instagram
                        </a>
                    </Button>
                </nav>

                <Sheet open={open} onOpenChange={setOpen}>
                    <SheetTrigger asChild className="md:hidden">
                        <Button variant="ghost" size="icon" data-testid="mobile-menu-btn" className="text-white">
                            <Menu className="h-6 w-6" />
                        </Button>
                    </SheetTrigger>
                    <SheetContent side="right" className="bg-[#0A0A0A] border-[#262626]" data-testid="mobile-menu">
                        <nav className="flex flex-col gap-6 mt-10">
                            {LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                                    className="text-lg font-display font-semibold uppercase tracking-tight text-white"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <Button asChild className="rounded-sm bg-[#E60000] hover:bg-[#c40000] text-white font-bold uppercase mt-4">
                                <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="mobile-instagram-btn">
                                    <Instagram className="h-4 w-4 mr-2" /> Instagram
                                </a>
                            </Button>
                        </nav>
                    </SheetContent>
                </Sheet>
            </div>
        </header>
        </>
    );
};
